// extracted by mini-css-extract-plugin
module.exports = {"container":"Oi","hero":"Pi","content":"Qi","typeProd":"Ri","notTransparent":"Si","sliderDots":"Ti","active":"Ui"};